import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faPhone,
  faEnvelope,
  faMapMarkerAlt,
  faChevronDown,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebook,
  faInstagram,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import "./AppNavbar.css";

type Props = {
  showSidebar?: VoidFunction;
};

export default function AppNavbar({ showSidebar }: Props) {
  const location = useLocation();
  
  const handleSidebarToggle = (evt: React.MouseEvent) => {
    evt.stopPropagation();
    showSidebar?.();
  };

  return (
    <nav className="app-navbar">
      <div className="navbar-top">
        <div className="navbar-top-container">
          <div className="navbar-contacts">
            <a href="tel:+393701627395" className="navbar-contact-item">
              <FontAwesomeIcon icon={faPhone} />
              <span>+39 370 162 7395</span>
            </a>
            <a href="tel:+390917669253" className="navbar-contact-item">
              <FontAwesomeIcon icon={faPhone} />
              <span>+39 091 766 9253</span>
            </a>
            <a
              href="mailto:centrodiotorino.mattina@gmail.com"
              className="navbar-contact-item"
            >
              <FontAwesomeIcon icon={faEnvelope} />
              <span>centrodiotorino.mattina@gmail.com</span>
            </a>
            <a
              href="https://maps.google.com/?q=Via+Capo+dell'Acqua+6,+Piazza+Duomo,+Partinico"
              target="_blank"
              rel="noopener noreferrer"
              className="navbar-contact-item"
            >
              <FontAwesomeIcon icon={faMapMarkerAlt} />
              <span>Via Capo dell'Acqua 6 (Piazza Duomo), Partinico</span>
            </a>
          </div>
          <div className="navbar-social">
            <a
              href="https://www.facebook.com/share/1AktcsfVdp/?mibextid=wwXIfr"
              className="navbar-social-link"
              aria-label="Facebook"
            >
              <FontAwesomeIcon icon={faFacebook} />
            </a>
            <a
              href="https://www.instagram.com/gianfranco.mattina.otorino?igsh=Y3ZuMjkyN2d6em1w&utm_source=qr"
              className="navbar-social-link"
              aria-label="Instagram"
            >
              <FontAwesomeIcon icon={faInstagram} />
            </a>
            <a
              href="https://www.linkedin.com/in/gianfranco-mattina-b2775b8a?utm_source=share_via&utm_content=profile&utm_medium=member_ios"
              className="navbar-social-link"
              aria-label="LinkedIn"
            >
              <FontAwesomeIcon icon={faLinkedin} />
            </a>
          </div>
        </div>
      </div>
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <img src={require("../assets/logos/0001.png")} alt="Logo" />
        </Link>

        <div className="navbar-menu">
          <Link to="/" className={`navbar-menu-link ${location.pathname === '/' ? 'active' : ''}`}>
            Home
          </Link>
          <div className="navbar-dropdown">
            <Link to="/visite" className={`navbar-menu-link navbar-dropdown-toggle ${location.pathname.startsWith('/visite') ? 'active' : ''}`}>
              Visite
              <FontAwesomeIcon icon={faChevronDown} className="dropdown-icon" />
            </Link>
            <div className="navbar-dropdown-menu">
              <Link
                to="/visite/otorinolaringoiatrica"
                className="navbar-dropdown-item"
              >
                Visita Otorinolaringoiatrica
              </Link>
              <Link to="/visite/pediatrica" className="navbar-dropdown-item">
                Visita Otorinolaringoiatrica Pediatrica
              </Link>
              <Link to="/visite/audiologica" className="navbar-dropdown-item">
                Visita Audiologica
              </Link>
            </div>
          </div>
          <Link to="/esami" className={`navbar-menu-link ${location.pathname === '/esami' ? 'active' : ''}`}>
            Esami
          </Link>
          <Link to="/servizi" className={`navbar-menu-link ${location.pathname === '/servizi' ? 'active' : ''}`}>
            Servizi
          </Link>
          <Link to="/centro-convenzionato" className={`navbar-menu-link ${location.pathname === '/centro-convenzionato' ? 'active' : ''}`}>
            Centro Convenzionato
          </Link>
          <Link to="/chi-siamo" className={`navbar-menu-link ${location.pathname === '/chi-siamo' ? 'active' : ''}`}>
            Chi Siamo
          </Link>
          <Link to="/contatti" className={`navbar-menu-link ${location.pathname === '/contatti' ? 'active' : ''}`}>
            Contatti
          </Link>
          <Link to="/#prenota" className="navbar-menu-link navbar-menu-cta">
            Prenota
          </Link>
        </div>

        <button
          className="navbar-menu-btn"
          onClick={handleSidebarToggle}
          aria-label="Menu"
        >
          <FontAwesomeIcon icon={faBars} />
        </button>
      </div>
    </nav>
  );
}
